export type ReturnLocation = { pathname: string; search: string };

const toRelativeTarget = (target: unknown): string | null => {
  if (typeof target === 'string') return target;
  if (typeof target !== 'object' || target === null) return null;
  const { pathname, search } = target as { pathname?: unknown; search?: unknown };
  if (typeof pathname !== 'string' || (search !== undefined && typeof search !== 'string')) return null;
  return pathname + (search ?? '');
};

const isSameOriginPath = (url: URL, origin: string): boolean =>
  url.origin === new URL(origin).origin && url.pathname.startsWith('/') && !url.pathname.startsWith('//');

// Returns the resolved path, never the input. The router decodes the path again, so check that too.
export function toSafeReturnLocation(target: unknown, origin: string): ReturnLocation | null {
  const relative = toRelativeTarget(target);
  if (relative === null) return null;
  try {
    const url = new URL(relative, origin);
    const decoded = new URL(decodeURI(url.pathname) + url.search, origin);
    return isSameOriginPath(url, origin) && isSameOriginPath(decoded, origin)
      ? { pathname: url.pathname, search: url.search }
      : null;
  } catch {
    return null;
  }
}
